import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LoaderService {
  static loaderSubject = new Subject();

  constructor() {}

  show() {
    LoaderService.loaderSubject.next({ show: true });
  }

  hide() {
    window.alert('Vos messages ont été envoyés');
    LoaderService.loaderSubject.next({ show: false });
  }
}



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/loader/loader.service.ts